import BaseChannel from "./BaseChannel";

export default class PingChannel extends BaseChannel {
  static channelName = "PingChannel";
}
